import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface DrawerContextState {
  isDrawerOpen: boolean;
  isNavOpen: boolean;
  toggleDrawer: (newState?: boolean) => void;
  toggleNav: (newState?: boolean) => void;
}

export const DrawerContext = createContext<DrawerContextState>({
  isDrawerOpen: false,
  isNavOpen: false,
  toggleDrawer: noop,
  toggleNav: noop,
});

export const useDrawerContext = () => useContext(DrawerContext);
